import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { JANE_STREET_PFOF_JOB_BASE_PATH } from '../../../../../../../../../../features/vendor/jane-street/pfof/job/jane-street-pfof-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jane-street/pfof/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'jane-street-pfof-job-list',
        label: 'Jane Street',
        to: JANE_STREET_PFOF_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
